var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path3, _path4, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _path5, _path6, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _ellipse, _path7, _path8, _path9, _ellipse2, _path10, _path11, _path12, _ellipse3, _path13, _path14, _path15, _ellipse4, _path16, _path17, _path18, _ellipse5, _path19, _path20, _path21, _ellipse6, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _rect23, _rect24, _rect25, _path32, _rect26, _rect27, _rect28;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMaintenance = function SvgMaintenance(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 612,
    height: 276,
    viewBox: "0 0 612 276",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 534.14,
    y: 112,
    width: 18,
    height: 64,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M565.14 163.238L520.169 110L429.899 110.821L375.14 163.896L376.246 164.604H375.851V275H565.019V164.604L565.14 163.238Z",
    fill: "#E5EBED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M520.33 110L464.14 175.589V275H565.14V163.111L520.33 110Z",
    fill: "#E5EBED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 504.14,
    y: 220,
    width: 21,
    height: 18,
    fill: "#3F3D56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 504.14,
    y: 189,
    width: 21,
    height: 18,
    fill: "#3F3D56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 504.14,
    y: 220,
    width: 21,
    height: 18,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 504.14,
    y: 189,
    width: 21,
    height: 18,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 413.14,
    y: 216,
    width: 21,
    height: 18,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 413.14,
    y: 183,
    width: 21,
    height: 18,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.58,
    x: 388.14,
    y: 112,
    width: 18,
    height: 64,
    fill: "#E5EBED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M419.14 163.238L374.169 110L283.899 110.821L229.14 163.896L230.246 164.604H229.851V275H419.019V164.604L419.14 163.238Z",
    fill: "#E5EBED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M373.33 110L317.14 175.589V275H418.14V163.111L373.33 110Z",
    fill: "#E5EBED"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 358.14,
    y: 220,
    width: 21,
    height: 18,
    fill: "#3F3D56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 358.14,
    y: 189,
    width: 21,
    height: 18,
    fill: "#3F3D56"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 358.14,
    y: 220,
    width: 21,
    height: 18,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 358.14,
    y: 189,
    width: 21,
    height: 18,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 267.14,
    y: 216,
    width: 21,
    height: 18,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 267.14,
    y: 183,
    width: 21,
    height: 18,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.574787,
    x: 233.14,
    y: 57,
    width: 25,
    height: 85,
    fill: "#E5EBED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.574787,
    d: "M274.14 125.306L214.021 54L93.344 55.0995L20.1397 126.188L21.6185 127.136H21.0904V275H273.978V127.136L274.14 125.306Z",
    fill: "#E5EBED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M213.245 54L138.14 141.849V275H273.14V125.137L213.245 54Z",
    fill: "#E5EBED"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 193.14,
    y: 201,
    width: 27,
    height: 24,
    fill: "#3F3D56"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 193.14,
    y: 159,
    width: 27,
    height: 24,
    fill: "#3F3D56"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 193.14,
    y: 201,
    width: 27,
    height: 24,
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 193.14,
    y: 159,
    width: 27,
    height: 24,
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 71.1397,
    y: 195,
    width: 27,
    height: 24,
    fill: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 71.1397,
    y: 153,
    width: 27,
    height: 24,
    fill: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 0.139679,
    y: 275,
    width: 590,
    height: 1,
    fill: "#3F3D56"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.1397,
    cy: 215.5,
    rx: 18,
    ry: 36.5,
    fill: "#003349"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9258 275C87.6885 232.634 93.863 190.421 93.9261 190L95.1394 190.233C95.0766 190.652 88.9375 232.643 95.1397 274.771L93.9258 275Z",
    fill: "#FFAD02"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.588 216.504L108.704 207.89L109.368 209.131L93.2523 217.745L92.588 216.504Z",
    fill: "#FFAD02"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5792 213.446L76.2438 212.205L92.3576 220.823L91.6929 222.064L75.5792 213.446Z",
    fill: "#FFAD02"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.1397,
    cy: 160,
    rx: 35,
    ry: 71,
    fill: "#FFD00A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8631 276C41.0503 192.264 53.7338 108.833 53.8634 108L55.1394 108.235C55.0101 109.066 42.3638 192.273 55.1397 275.769L53.8631 276Z",
    fill: "#3F3D56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6783 161.824L81.1993 144.977L81.8636 146.218L50.3426 163.065L49.6783 161.824Z",
    fill: "#3F3D56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4118 154.657L17.0764 153.416L48.5928 170.272L47.9282 171.513L16.4118 154.657Z",
    fill: "#3F3D56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.64,
    cy: 116.5,
    rx: 47.5,
    ry: 97.5,
    fill: "#FFAD02"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M138.878 276C121.555 161.361 138.703 47.1402 138.878 46L140.139 46.2356C139.964 47.3738 122.853 161.37 140.14 275.769L138.878 276Z",
    fill: "#3F3D56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M132.168 120.073L175.302 97.0194L175.966 98.2604L132.832 121.314L132.168 120.073Z",
    fill: "#3F3D56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M86.645 109.809L87.3096 108.568L130.438 131.634L129.773 132.874L86.645 109.809Z",
    fill: "#3F3D56"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 533.14,
    cy: 215.5,
    rx: 18,
    ry: 36.5,
    fill: "#003349"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M532.354 275C538.591 232.634 532.416 190.421 532.353 190L531.14 190.233C531.203 190.652 537.342 232.643 531.14 274.771L532.354 275Z",
    fill: "#FFAD02"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M517.102 209.131L517.767 207.89L533.882 216.504L533.218 217.745L517.102 209.131Z",
    fill: "#FFAD02"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M534.113 220.823L550.226 212.205L550.891 213.446L534.777 222.064L534.113 220.823Z",
    fill: "#FFAD02"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 576.14,
    cy: 160,
    rx: 35,
    ry: 71,
    fill: "#FFD00A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M572.416 276C585.229 192.264 572.546 108.833 572.416 108L571.14 108.235C571.269 109.066 583.916 192.273 571.14 275.769L572.416 276Z",
    fill: "#3F3D56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M544.607 146.218L545.271 144.977L576.792 161.824L576.128 163.065L544.607 146.218Z",
    fill: "#3F3D56"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M577.877 170.272L609.394 153.416L610.059 154.657L578.542 171.513L577.877 170.272Z",
    fill: "#3F3D56"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 494.64,
    cy: 116.5,
    rx: 47.5,
    ry: 97.5,
    fill: "#FFAD02"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M488.401 276C505.725 161.361 488.576 47.1402 488.401 46L487.14 46.2356C487.315 47.3738 504.426 161.37 487.14 275.769L488.401 276Z",
    fill: "#3F3D56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M450.504 98.2604L451.169 97.0194L494.303 120.073L493.638 121.314L450.504 98.2604Z",
    fill: "#3F3D56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M496.033 131.634L539.161 108.568L539.825 109.809L496.697 132.874L496.033 131.634Z",
    fill: "#3F3D56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M360.527 62.3569L366.14 58.0602C361.779 57.5997 359.988 59.8758 359.255 61.6774C355.848 60.3235 352.14 62.0978 352.14 62.0978L363.37 66C362.803 64.5516 361.817 63.2879 360.527 62.3569Z",
    fill: "#003349"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M223.527 22.3569L229.14 18.0602C224.779 17.5997 222.988 19.8758 222.255 21.6774C218.848 20.3235 215.14 22.0978 215.14 22.0978L226.37 26C225.803 24.5516 224.817 23.2879 223.527 22.3569Z",
    fill: "#003349"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M448.527 4.35691L454.14 0.0601733C449.779 -0.400266 447.988 1.87583 447.255 3.67738C443.848 2.32349 440.14 4.09782 440.14 4.09782L451.37 8C450.803 6.55163 449.817 5.28788 448.527 4.35691Z",
    fill: "#003349"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M458.639 268.067C457.148 268.067 455.683 268.411 454.392 269.064C451.714 266.944 447.859 266.405 444.56 267.689C441.26 268.974 439.135 271.839 439.14 275H467.14C466.823 271.095 463.112 268.068 458.639 268.067Z",
    fill: "#003349"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M173.639 268.067C172.148 268.067 170.683 268.411 169.392 269.064C166.714 266.944 162.859 266.405 159.56 267.689C156.26 268.974 154.135 271.839 154.14 275H182.14C181.823 271.095 178.112 268.068 173.639 268.067Z",
    fill: "#003349"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M319.639 268.067C318.148 268.067 316.683 268.411 315.392 269.064C312.714 266.944 308.859 266.405 305.56 267.689C302.26 268.974 300.135 271.839 300.14 275H328.14C327.823 271.095 324.112 268.068 319.639 268.067Z",
    fill: "#003349"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M290.14 248H209.14V250.571H221.772V275H224.385V250.571H273.588V275H276.201V250.571H290.14V248Z",
    fill: "#003349"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 209.14,
    y: 240,
    width: 81,
    height: 2,
    fill: "#003349"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 209.14,
    y: 233,
    width: 81,
    height: 2,
    fill: "#003349"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 209.14,
    y: 227,
    width: 81,
    height: 2,
    fill: "#003349"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M416.14 248H335.14V250.571H347.772V275H350.385V250.571H399.587V275H402.201V250.571H416.14V248Z",
    fill: "#003349"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 335.14,
    y: 240,
    width: 81,
    height: 2,
    fill: "#003349"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 335.14,
    y: 233,
    width: 81,
    height: 2,
    fill: "#003349"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 335.14,
    y: 227,
    width: 81,
    height: 2,
    fill: "#003349"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMaintenance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/maintenance.c90d4c14.svg";
export { ForwardRef as ReactComponent };